import React from 'react'
import { Table, Column, AutoSizer} from 'react-virtualized'
import { Loading } from './Loading';
import { TitleWindowSummaryAsync, TitleWindowItemsAsync } from './fetchData';
import Select from 'react-select';
import cn from 'classnames';
import RecordView from './Dialogs/RecordView/RecordView';
import Notes from './NotesPanel';
import "abortcontroller-polyfill/dist/polyfill-patch-fetch"

export default class TitleWindow extends React.PureComponent {

	constructor(props) {
		super(props);
		const viewID = props.id
		const datasetID = props.datasetID
		const mainPanelSelection = props.mainPanelSelection
		const DetailSelection = props.detailSelection
		const Note = props.Note;
		const DefaultTitleFieldID = props.DefaultField;
		const FieldArray = props.FieldArray;
		const appURL = props.appURL

		this.state = {
			names: [],
			recs: [],
			ListName: '',
			datasetID: datasetID,
			viewID: viewID,
			selectedFieldID: '',
			DefaultTitleFieldID: DefaultTitleFieldID,
			loading: true,
			reloading: false,
			appURL: appURL,
			disableHeader: false,
			headerHeight: 20,
			hideIndexRow: false,
			overscanRowCount: 10,
			rowHeight: 20,
			rowCount: 1,
			totalRows: 1,
			columnCount: 1,
			selectedIDs: [],
			sortBy: "Name",
			sortDirection: "AlphaAsc",
			sortedList: "",
			useDynamicRowHeight: false,
			mainPanelSelection: mainPanelSelection,
			fieldNames: FieldArray,
			detailSelection: DetailSelection,
			showRecordView: false,
			sortOrderArray: [],
			titleWindowData: {
				showRecordView: false,
				RecordNumbers: []
			},
			defaultTitleField: "",
			sheetNote: Note
		};

		this._getDatum = this._getDatum.bind(this);
		this._columnCellRenderer = this._columnCellRenderer.bind(this);
		this._headerRenderer = this._headerRenderer.bind(this);
		this.updateTitleWindow = this.updateTitleWindow.bind(this);
		this._noRowsRenderer = this._noRowsRenderer.bind(this);
		this.onRowClick = this.onRowClick.bind(this);
		this.onRowDoubleClick = this.onRowDoubleClick.bind(this);
		this._sort = this._sort.bind(this);
	}
	fetchData(appURL, fields, DefaultTitleFieldID){
		let defaultTitle = "";
		let selectedFieldID = "";
		for (let item in fields){
			if (String(fields[item].value) === DefaultTitleFieldID){
				defaultTitle = fields[item].label;
				selectedFieldID = String(fields[item].value)
			}
		}
		if (this.mounted){
			this.setState({
				fieldNames: fields,
				loading: false,
				defaultTitleField: defaultTitle,
				selectedFieldID: selectedFieldID,
				fieldAndRecordsSelected: false,
				sortOrderArray: []
			})
		}
	}
	componentDidMount(){
		this.mounted = true;
		this.fetchData(this.state.appURL, this.state.fieldNames, this.state.DefaultTitleFieldID)
	}
	componentDidUpdate(prevProps, prevState){
		if (JSON.stringify(prevProps.mainPanelSelection) !== JSON.stringify(this.props.mainPanelSelection) || this.state.selectedFieldID !== prevState.selectedFieldID || prevState.sortDirection !== this.state.sortDirection){
			if (this.state.selectedFieldID !== '' && this.props.mainPanelSelection.bSelection){
				this.setState({
					reloading: true,
					names: [],
					recs: [],
					rowCount: 0,
					totalRows: 0,
				})
				TitleWindowSummaryAsync(this.state.appURL, this.state.datasetID, this.state.selectedFieldID, this.state.viewID, this.props.mainPanelSelection, this.props.mainPanelSelection.browserSelectString, this.abortControllerSummary.signal)
				.then((RowCount) => {
					let sortOrderArray = [];
					let sortDirection = this.state.sortDirection
					if (RowCount > 0){
						//let tempRowCount = (RowCount > 10 ? 10 : RowCount)
						for (let i=0; i<RowCount; i++){
							sortOrderArray.push(i);
						}
						let Blocks = 1;
						//let myTimeout = setTimeout(() => {
							let fetchBlocks = 500;
							for (var index = 0; index < RowCount; index += fetchBlocks) {
								TitleWindowItemsAsync(this.state.appURL, this.state.datasetID, this.state.selectedFieldID, this.state.viewID, this.props.mainPanelSelection, this.props.mainPanelSelection.browserSelectString, index, fetchBlocks, sortDirection, this.abortControllerItems.signal)
								.then((data) => {
									let names = this.state.names
									let recs = this.state.recs
									if (names !== []){
										names = names.concat(JSON.parse(data.RowLabels.names))
										recs = recs.concat(JSON.parse(data.RowLabels.recs))
									}
									else {
										names = JSON.parse(data.RowLabels.names)
										recs = JSON.parse(data.RowLabels.recs)
									}
									if (this.mounted){
										this.setState({
											names: names,
											recs: recs,
											rowCount: RowCount,
											totalRows: RowCount,
											mainPanelSelection: this.props.mainPanelSelection,
											fieldAndRecordsSelected: true,
											sortOrderArray: sortOrderArray,
											reloading: false
										})
									}
								})
							}
						//}, Blocks)
					}
					else {						
						this.setState({
							names: [],
							recs: [],
							rowCount: 0,
							totalRows: 0,
							sortOrderArray: [],
							reloading: false
						})
					}
				})
			}
			else if (!this.props.mainPanelSelection.bSelection){
				if (this.mounted){
					this.setState({
						names: [],
						recs: [],
						rowCount: 0,
						totalRows: 0,
						mainPanelSelection: this.props.mainPanelSelection,
						fieldAndRecordsSelected: false,
						sortOrderArray: []
					})
				}
			}

		}
		else if (prevProps.detailSelection !== this.props.detailSelection) {
			const newDetailSelection = this.props.detailSelection;
			let newSortOrder = [];
			for (let prop in this.state.recs){
				if (newDetailSelection.indexOf(parseInt(this.state.recs[prop], 10)) >= 0){
					//sort to top
					newSortOrder.unshift(prop)
				}
				else {
					//move to bottom
					newSortOrder.push(prop)
				}
			}
			if (this.mounted){
				this.setState({
					detailSelection: newDetailSelection,
					sortOrderArray: newSortOrder,
					selectedIDs: []
				})
			}
		}
	}
	componentWillUnmount(){
		this.mounted = false;
		this.abortControllerFields.abort();
		this.abortControllerSummary.abort();
		this.abortControllerItems.abort();
	}
	abortControllerFields = new window.AbortController();
	abortControllerSummary = new window.AbortController();
	abortControllerItems = new window.AbortController();
	closeRecordView = () => {
		const titleWindowData = {
			showRecordView: false,
			RecordNumbers: []
		}
		if (this.mounted){
			this.setState({
				titleWindowData: titleWindowData
			})
		}
	}

	PrevNextRecord = (dir) => {
		let currentRecord = this.state.lastSelection
		if (dir === "PREV"){
			//go to previous record
			if (currentRecord !== 0){
				currentRecord -= 1;
			}
		}
		else {
			//go to next record
			if (currentRecord < this.state.rowCount - 1 ){

				currentRecord += 1;
			}
		}
		const newRecord = this._getDatum(currentRecord)
		const recordToSelect = String(newRecord.RecordNumber)
			let titleWindowdata = {
				showRecordView: true,
				RecordNumbers: [recordToSelect]
			}
		if (this.mounted){
			this.setState({
				titleWindowData: titleWindowdata,
				selectedIDs: [recordToSelect],
				lastSelection: currentRecord,
			})
		}
	}
	render() {
		const {
			disableHeader,
			headerHeight,
			hideIndexRow,
			overscanRowCount,
			columnCount,
			autoWidth,
			rowCount,
			scrollToIndex,
			sortBy,
			sortedList,
			fieldNames,
			useDynamicRowHeight,
			rowHeight,
			detailSelection,
			defaultTitleField,
			selectedIDs,
			appURL
		} = this.state;
		const rowGetter = ({index}) => this._getDatum(index);
		return (
			<div className="fullHeight">
				{this.state.loading === true
				? <Loading />
				: <div className="TitleWindow">
				{/*<Select defaultValue={defaultTitleField} options={fieldNames} onChange={this.updateTitleWindow}></Select>*/}
				<div className="TitleFieldName">{defaultTitleField}</div>
				{this.state.reloading === true
				? <Loading />
				: this.state.fieldAndRecordsSelected === false
				? <div></div>
			:<AutoSizer>
				{({height, width}) => (
				<Table
					disableHeader={disableHeader}
					headerClassName={"TitleHeaderRow"}
					headerHeight={headerHeight}
					height={height}
					className={"TitleWindowGrid"}
					noRowsRenderer={this._noRowsRenderer}
					overscanRowCount={overscanRowCount}
					rowGetter={rowGetter}
					rowCount={rowCount}
					rowHeight={rowHeight}
					columnCount={columnCount}
					scrollToIndex={scrollToIndex}
					detailSelection={detailSelection}
					sort={this._sort}
					sortBy={sortBy}
					onRowClick={this.onRowClick}
					onRowDoubleClick={this.onRowDoubleClick}
					width={width}>
					<Column
						dataKey="Name"
						cellRenderer={this._columnCellRenderer}
						headerRenderer={this._headerRenderer}
						width={width}
					/>
				</Table>
				)}
			</AutoSizer>
				}
				</div>                        
				}
				{this.state.titleWindowData.showRecordView &&
					<RecordView appURL={appURL} datasetID={this.state.datasetID} recordSet={this.state.titleWindowData.RecordNumbers} closeThisView={this.closeRecordView} ChangeRecord={this.PrevNextRecord}/>
				}
				{this.state.sheetNote === "" ?
				<div className="empty"></div>
				:<div className="NotesPanel">
					<Notes Note={this.state.sheetNote}></Notes>
				</div>
				}
			</div>
		)
	}

	_sort() {
		let newSortDirection = "AlphaDesc"
		if (this.state.sortDirection === "AlphaDesc"){
			newSortDirection = "AlphaAsc"
		}
		//const unsortedList = this.state.names
		//const sortedList = sortObject(unsortedList, "Name", newSortDirection)
		
		if (this.mounted){
			this.setState({
				sortDirection: newSortDirection, 
				//sortOrderArray: sortedList
			});
		}
	}
		
	_columnCellRenderer = ({dataKey, parent, rowIndex}) => {
		const selectedIds = this.state.selectedIDs;
		const selectedDetailIds = this.state.detailSelection;
		const datum = this._getDatum(rowIndex)
		let classNames;
		if (selectedIds.indexOf(String(datum.RecordNumber)) >= 0){
			classNames = "selected";
		}
		else if (selectedDetailIds.includes(parseInt(datum.RecordNumber, 10))){
			classNames = cn("selected", "detailSelect")
		}
		return (
			<div key={datum.RecordNumber} className={classNames} title={datum[dataKey]} style={{whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>
				{datum[dataKey]}
			</div>
		);
	};
			
	_noRowsRenderer() {
		return <div className={"noRows"}>No rows</div>;
	}
	_getDatum( index) {
		let returnObj = {
			Name: this.state.names[this.state.sortOrderArray[index]],
			RecordNumber: this.state.recs[this.state.sortOrderArray[index]]
		}
		return returnObj;
	}

	onRowDoubleClick (event){
			let titleWindowdata = {
				showRecordView: true,
				RecordNumbers: this.state.selectedIDs
			}
			if (this.mounted){
				this.setState({
					titleWindowData: titleWindowdata
				})
			}
		//this.props.callbackFromParent(titleWindowdata)

	}
	onRowClick = (event) => {
		const titles = this.state.recs;
		event.event.stopPropagation();
		event.event.preventDefault();
		if (event.event.ctrlKey){

			if (this.mounted){
				this.setState({
					selectedIDs: this.state.selectedIDs.concat(String(event.rowData.RecordNumber)),
					lastSelection: event.index
				});
			}
		}
		else if (event.event.shiftKey){
			if (this.state.lastSelection !== ""){
				let finalArray = [];
				const numToSelect = Math.abs(this.state.lastSelection - event.index)
				if (this.state.lastSelection > event.index){
					for (let i=event.index; i<=this.state.lastSelection; i++){
						finalArray.push(String(titles[this.state.sortOrderArray[i]]));
					}
				}
				else if ((this.state.lastSelection < event.index)) {
					for (let i=event.index; i>=this.state.lastSelection; i--){
						finalArray.push(String(titles[this.state.sortOrderArray[i]]));
					}
				}
				else {
					finalArray = this.state.selectedIDs;
				}
				if (this.mounted){
					this.setState({
						selectedIDs: finalArray,
						lastSelection: event.index
					});
				}
			}
		}
		else {
			
			if (this.mounted){
				this.setState({
					selectedIDs: [String(event.rowData.RecordNumber)],
					lastSelection: event.index,
					detailSelection: []
				});
			}
		}
	}
	updateTitleWindow(val){
		if (this.mounted){
			this.setState({
				selectedFieldID: val.value,
			})
		}
	}
	_headerRenderer({dataKey, sortBy}) {
		const selectedRecs = arrayUnique(this.state.selectedIDs.concat(this.state.detailSelection))

		return (
			<div onClick={() => this._sort}>
				{this.state.rowCount + " Titles, " + selectedRecs.length + " Selected"}
			</div>
		);
	}    
}

function arrayUnique(array) {
	let a = array.concat();
	for(let i=0; i<a.length; ++i) {
			for(let j=i+1; j<a.length; ++j) {
					if(a[i] === a[j])
							a.splice(j--, 1);
			}
	}

	return a;
}


function sortObject(arr, propMatch, order) {
	const property_type = typeof arr[0];
	arr.sort(function(a, b) {
		if (property_type === 'string'){
			return ((order === 'Desc') ? a.value.localeCompare(b.value) : b.value.localeCompare(a.value) );
		}
		else {
			return ((order === 'Desc') ? b.value - a.value : a.value - b.value);
		}
	});
	let sortOrder = arr.map(function(key, index){
		return index;
	})
	return sortOrder; // returns array
}